import React from "react";
import { SortableList } from "../SortableList";
import { ButtonWithIcon, SmallNoPaddingIconButton } from "../ButtonWithIcon";
import EditItemDialog from "./EditWhatsNewItemDialog";
import { IconCirclePlus, IconEdit, IconTrash } from "@tabler/icons-react";

export default function EditWhatsNewSortableList({
	whatsNewItems,
	updateWhatsNewItems,
	addWhatsNewItem,
	deleteWhatsNewItem,
	openEditItemDialog,
	editItemDialogOpen,
	closeEditItemDialog,
	editItemText,
	editItemUrl,
	handleEditItemChange,
	submitEditItemDialog,
	isNewItem,
}) {
	return (
		<div>
			<EditItemDialog
				editItemDialogOpen={editItemDialogOpen}
				title={`${isNewItem ? "Add" : "Edit"} Item`}
				mainContent={"This is the edit item dialog"}
				closeEditItemDialog={closeEditItemDialog}
				editItemText={editItemText}
				editItemUrl={editItemUrl}
				handleEditItemChange={handleEditItemChange}
				submitEditItemDialog={submitEditItemDialog}
			/>
			<div>
				The order of the items display below is the order they will be
				displayed in the whats new dropdown
			</div>
			<div style={{ paddingBottom: 10, paddingTop: 10 }}>
				<ButtonWithIcon
					handler={addWhatsNewItem}
					buttonText="Add Item"
					iconComponent={
						<IconCirclePlus
							size={16}
							style={{ verticalAlign: "middle" }}
						/>
					}
				/>
			</div>
			<div className="SortableListContainer">
				<SortableList
					items={whatsNewItems}
					onChange={updateWhatsNewItems}
					renderItem={(item) => (
						<SortableList.Item id={item.id}>
							<div>
								<div>{item.text}</div>
							</div>
							<div
								style={{
									display: "flex",
									gap: 8,
								}}
							>
								<span style={{ minWidth: 80 }}>
									<ButtonWithIcon
										handler={() => openEditItemDialog(item)}
										buttonText="Edit"
										iconComponent={
											<IconEdit
												size={16}
												style={{
													verticalAlign: "middle",
												}}
											/>
										}
										className="blue"
										id={item.id}
										item={item}
									/>
								</span>
								<SmallNoPaddingIconButton
									aria-label="delete"
									className="trash"
									onClick={() => deleteWhatsNewItem(item.id)}
								>
									<IconTrash size={30} />
								</SmallNoPaddingIconButton>
								<SortableList.DragHandle />
							</div>
						</SortableList.Item>
					)}
				/>
			</div>
		</div>
	);
}
